import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type {
  IPantallaTurno,
  IEstadoTurnoAdmision,
  IEstadoTurnoHoy,
  IColaOperador
} from '@/modules/Pantalla/interfaces/IPantallaTurno'

export class PantallaOperadorService extends BaseService<IPantallaTurno> {
  constructor() {
    super({ baseUrl: 'pantalla/turnos' })
  }

  async llamarPorAdmision(
    ciadId: number,
    consultorio?: string
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .post<IResponseApi<unknown>>('/llamar-admision', { ciadId, consultorio })
      .catch(this.errorHandle)
  }

  async atenderPorAdmision(
    ciadId: number
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .post<IResponseApi<unknown>>('/atender-admision', { ciadId })
      .catch(this.errorHandle)
  }

  async perderPorAdmision(
    ciadId: number
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .post<IResponseApi<unknown>>('/perder-admision', { ciadId })
      .catch(this.errorHandle)
  }

  async estadoPorAdmision(
    ciadId: number
  ): Promise<AxiosResponse<IResponseApi<IEstadoTurnoAdmision>>> {
    return this.http
      .get<IResponseApi<IEstadoTurnoAdmision>>(`/estado-admision/${ciadId}`)
      .catch(this.errorHandle)
  }

  async estadosHoy(): Promise<AxiosResponse<IResponseApi<IEstadoTurnoHoy[]>>> {
    return this.http
      .get<IResponseApi<IEstadoTurnoHoy[]>>('/estados-hoy')
      .catch(this.errorHandle)
  }

  async colasOperador(): Promise<AxiosResponse<IResponseApi<IColaOperador[]>>> {
    return this.http
      .get<IResponseApi<IColaOperador[]>>('/colas-operador')
      .catch(this.errorHandle)
  }

  async llamarPorTurno(
    turnoId: number,
    consultorio?: string
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .post<IResponseApi<unknown>>('/llamar-turno', { turnoId, consultorio })
      .catch(this.errorHandle)
  }

  async atenderPorTurno(
    turnoId: number
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .post<IResponseApi<unknown>>('/atender-turno', { turnoId })
      .catch(this.errorHandle)
  }

  async perderPorTurno(
    turnoId: number
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .post<IResponseApi<unknown>>('/perder-turno', { turnoId })
      .catch(this.errorHandle)
  }
}
